<template>
  <div v-if="userGoodies">
    <h1>User goodies</h1>
    <table v-if="userGoodies.length > 0" class="table table-sm table-striped">
      <thead>
      <tr>
        <th>User</th>
        <th>Goodie</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="userGoodie in userGoodies" :key="userGoodie.id">
        <!-- User -->
        <td>
          <router-link
              type="button"
              class="btn btn-primary btn-sm"
              :to="{name:'organisation-user',
            params: {
                username: userGoodie.user.username,
                slug: this.$route.params.slug
              }
          }">
            {{ userGoodie.user.last_name }} {{ userGoodie.user.first_name }}
            (${{ userGoodie.user.effective_user_shift_score }})
          </router-link>
        </td>
        <!-- Goodie -->
        <td>{{ userGoodie.goodie.name }} ({{
            userGoodie.goodie.n_confirmed_user_goodies
          }}/{{ userGoodie.goodie.capacity }})
        </td>
        <!-- Status -->
        <td>{{ userGoodie.status_display }}</td>
        <!-- Action -->
        <td>
          <!-- Confirm -->
          <button
              v-if="userGoodie.status!=='confirmed' && userGoodie.goodie.capacity > userGoodie.goodie.n_confirmed_user_goodies"
              type="button"
              class="btn btn-sm btn-success rounded-circle me-1" title="Confirm"
              :disabled="userGoodie.goodie.capacity <= userGoodie.goodie.n_confirmed_user_goodies"><i
              class="fa-solid fa-square-check"
              @click="updateUserGoodieStatus(userGoodie.id, 'confirmed')"></i></button>
          <!-- To pending -->
          <button v-if="userGoodie.status!=='pending'" type="button"
                  class="btn btn-sm btn-secondary rounded-circle me-1" title="To pending"><i
              class="fa-solid fa-circle-question"
              @click="updateUserGoodieStatus(userGoodie.id, 'pending')"></i></button>
          <!-- To waiting list -->
          <button v-if="userGoodie.status!=='waiting_list'" type="button"
                  class="btn btn-sm btn-warning rounded-circle me-1" title="To waiting list"><i
              class="fa-solid fa-hourglass-half"
              @click="updateUserGoodieStatus(userGoodie.id, 'waiting_list')"></i></button>
          <!-- Delete -->
          <button type="button" class="btn btn-sm btn-danger rounded-circle me-1" title="Delete"><i
              class="fa-solid fa-trash"
              @click="deleteUserGoodie(userGoodie.id)"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <h1>User goodies</h1>
    <p>Loading...</p>
  </div>
</template>

<script>
import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";
import {cancelRequestedGoodie} from "@/utils/userGoodieUtils";

export default {
  name: "OrganisationGoodiesAdmin",
  components: {},
  data() {
    return {
      userGoodies: null,
    }
  },
  mounted() {
    this.fetchOrganisationUserGoodiesDetails();
  },
  methods: {
    async fetchOrganisationUserGoodiesDetails() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/user-goodies`, {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          console.log('Organisation user goodies details:', data);
          this.userGoodies = data;
          document.title = `${this.data.code} - Goodies Admin`;
        }
      } catch (error) {
        console.error('Error fetching organisation goodies details:', error);
      }
    },
    async updateUserGoodieStatus(userGoodieId, status) {
      try {
        const response = await fetch(
            `${API_BASE_URL}/user-goodies/${userGoodieId}`, {
              method: 'PATCH',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken(),
              },
              body: JSON.stringify({status}),
            });
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          await this.fetchOrganisationUserGoodiesDetails();
        }
      } catch (error) {
        console.error('Error updating user goodie status:', error);
      }
    },
    async deleteUserGoodie(userGoodieId) {
      const confirmed = window.confirm("Are you sure you want to delete this user goodie?");
      if (confirmed) {
        await cancelRequestedGoodie(userGoodieId, getCSRFToken());
        await this.fetchOrganisationUserGoodiesDetails();
      }
    },
  }
}
</script>
